import styled, { css } from 'styled-components';
import { borderRadius, easing, colors, fontSizes, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { single, quarter, base, fiveEights } from 'ui/theme/spacing';
import { TabState, Tab } from './types';

export const TAB_STATES = {
  DEFAULT: 'DEFAULT',
  SELECTED: 'SELECTED',
  DISABLED: 'DISABLED',
  DISABLED_SELECTED: 'DISABLED_SELECTED',
};

export const TAB_STYLES = {
  [TabState.Default]: css`
    color: ${colors.textPrimary};
    background: transparent;
    transition: all 120ms ${easing.entrance};
    &:hover {
      background: ${colors.backgroundInteractive};
      color: ${colors.textLink};
      cursor: pointer;
    }
  `,
  [TabState.Selected]: css`
    background: ${colors.backgroundInteractiveStrong};
    color: ${colors.textOnColor};
  `,
  [TabState.Disabled]: css`
    color: ${colors.textDisabled};
  `,
  [TabState.DisabledSelected]: css`
    background: ${colors.backgroundDisabledStrong};
    color: ${colors.white};
  `,
};

export const TAB_LABEL_STYLE = {
  ...body2,
  lineHeight: fontSizes.s16,
  color: null,
};

export const squareThemeStyling = css<{ tabState: TabState }>`
  border-radius: 0;
  border-bottom: ${single} solid
    ${({ tabState }) =>
      tabState === TabState.Selected ? colors.borderInteractive : colors.borderPrimary};
  margin-right: 0;
  background: transparent;
  color: ${({ tabState }) => tabState === TabState.Selected && colors.textLink};
  :before {
    border: none;
  }
`;

export const StyledButton = styled.button<{
  tabState: TabState;
  squareTheme: Tab['squareTheme'];
}>`
  ${body2}
  padding: ${fiveEights} ${base};
  align-items: center;
  cursor: pointer;
  border-radius: ${borderRadius.full};
  border: ${single} solid transparent;
  outline: none;
  overflow: visible;
  position: relative;
  margin-right: ${quarter};
  ${({ tabState }) => TAB_STYLES[tabState]};
  :before {
    border-radius: ${borderRadius.full};
    border: ${pxToRem(1.5)} solid;
    border-color: ${({ tabState }) =>
      tabState === TabState.Selected ? colors.borderInteractiveStrong : colors.borderInteractive};
    content: '';
    display: block;
    inset: -${quarter};
    opacity: 0;
    position: absolute;
    transition: all 0.2s;
    z-index: 0;
  }
  :focus-visible {
    :before {
      opacity: 1;
    }
    color: ${({ tabState }) =>
      tabState === TabState.Selected ? colors.textOnColor : colors.textLink};
    background: ${({ tabState }) =>
      tabState === TabState.Selected
        ? colors.backgroundInteractiveStrong
        : colors.backgroundInteractive};
  }
  ${({ squareTheme }) => squareTheme && squareThemeStyling}
`;

export const StyledTabLabel = styled.span`
  ${body2}
  font-size: ${fontSizes.s15};
  line-height: ${fontSizes.s16};
  color: unset;
`;

export const TabGroupContainer = styled.div`
  display: inline-block;
`;
